var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"editor"}),_vm._v(" "),_c('choose-photo',{ref:"choose",attrs:{"config":_vm.img.config,"field":_vm.img.field,"quote":2},on:{"selectUrl":_vm.addImg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }